import LearnPageLayout from "@/components/LearnPageLayout";
import { page4 } from "./learnDataP4";

const SaintCoralSpringsPage = () => (
  <LearnPageLayout
    title={page4.title}
    description={page4.description}
    canonical={page4.canonical}
    h1={page4.h1}
    breadcrumbLabel={page4.breadcrumbLabel}
    crumbs={page4.crumbs}
    shortAnswer={page4.shortAnswer}
    keyTakeaways={page4.keyTakeaways}
    sections={page4.sections}
    faqs={page4.faqs}
    sources={page4.sources}
    schemaJson={page4.schemaJson}
    relatedLinks={page4.relatedLinks}
  />
);

export default SaintCoralSpringsPage;
